/**
 * Capa responsive empresarial reutilizable (Fase 0).
 * -----------------------------------------------------------------------------
 * Registra globalmente los componentes responsive para poder usarlos en
 * cualquier vista sin imports repetidos. Solo aporta marcado/estilo
 * adaptativo: NO contiene ni altera lógica de negocio.
 *
 * Componentes:
 *   <ResponsiveTable>   - scroll horizontal seguro para tablas en móvil.
 *   <ResponsiveToolbar> - barra de filtros/acciones que apila en móvil.
 *   <FormGrid> / <FormField> - grilla de formulario con reparto responsive.
 *   <ResponsiveSplit>   - dos paneles lado a lado en desktop, apilados en móvil.
 *
 * Mixin (import directo donde se necesite presentación condicional):
 *   import deviceMixin from "@/components/responsive/deviceMixin";
 *
 * Registro (en main.js):  import ResponsiveKit from "@/components/responsive";
 *                         Vue.use(ResponsiveKit);
 */
import ResponsiveTable from "./ResponsiveTable.vue";
import ResponsiveToolbar from "./ResponsiveToolbar.vue";
import FormGrid from "./FormGrid.vue";
import FormField from "./FormField.vue";
import ResponsiveSplit from "./ResponsiveSplit.vue";
import ResponsiveCards from "./ResponsiveCards.vue";
import BottomNav from "./BottomNav.vue";

const components = {
  ResponsiveTable,
  ResponsiveToolbar,
  FormGrid,
  FormField,
  ResponsiveSplit,
  ResponsiveCards,
  BottomNav,
};

export default {
  install(Vue) {
    Object.keys(components).forEach((name) => {
      Vue.component(name, components[name]);
    });
  },
};

export {
  ResponsiveTable,
  ResponsiveToolbar,
  FormGrid,
  FormField,
  ResponsiveSplit,
  ResponsiveCards,
  BottomNav,
};
